<template>
  <div class="box">
    <div class="loading" v-if="!dataUrl">
      <van-loading size="24px" vertical>图片生成中...</van-loading>
    </div>
    <img class="bg" v-if="signInfo.backgroundImage" :src="signInfo.backgroundImage" />
    <div v-if="!dataUrl" id="longshare" class="container"
      :style="{ backgroundImage: `url(${signInfo.backgroundImage || ''})` }">
      <div class="english">{{ signInfo.englishContent }}</div>
      <div class="chinese">{{ signInfo.chineseContent }}</div>
      <div class="bottom">
        <div class="info">
          <img crossorigin="anonymous" class="avatar" :src="avatar" />
          <div class="desc">
            <div class="nickname">{{ userInfo.nickName }}</div>
          </div>
        </div>
        <div class="data">
          <div class="data-item">
            <div class="text">加入圈子</div>
            <div class="num">{{ studyInfo.joinCheckinDays || 0 }}<span class="unit">天</span></div>
          </div>
          <div class="data-border"></div>
          <div class="data-item">
            <div class="text">已打卡</div>
            <div class="num">{{ studyInfo.totalCheckinDays || 0 }}<span class="unit">天</span></div>
          </div>
          <div class="data-border"></div>
          <div class="data-item">
            <div class="text">连续打卡</div>
            <div class="num">{{ studyInfo.consecutiveCheckinDays || 0 }}<span class="unit">天</span></div>
          </div>
        </div>
        <div class="bottom-border"></div>
        <div class="intro">
          <div class="intro-left">
            <img crossorigin="anonymous" class="logo" src="@/assets/img/logo.png" />
            <div class="intro-desc">{{ topic }}</div>
          </div>
          <img crossorigin="anonymous" class="intro-code" src="@/assets/img/longSentence.jpg" />
        </div>
      </div>
    </div>
    <div class="modal">
      <img v-if="showBtn" class="success" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/circle/success.png" />
      <img crossorigin="anonymous" class="pic" :src="dataUrl" />
      <div class="tip">长按图片可以保存图片或转发给好友</div>
      <div v-if="showBtn" class="review" @click="goLongSentenceList">复习一下</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import {
  getSignImage,
  getLongCircleInfo,
} from '@/api/share';
import html2canvas from 'html2canvas';
import wx from 'weixin-js-sdk';
import { whatEev } from '@/utils/tools';

export default {
  data() {
    return {
      studyInfo: {},
      signInfo: {},
      avatar: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/defaultAvatar.png',
      nickname: '',
      dataUrl: '',
      showBtn: false,
      topic: '',
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    document.title = '打卡圈';
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      async handler(value) {
        if (value.id) {
          if (value.avatar) {
            this.avatar = value.avatar;
          }
          await this.reqStudyInfo();
          await this.reqSignInfo();
        }
      },
    },
  },
  methods: {
    async reqStudyInfo() {
      const { circleId, mode, topic } = this.$route.query;
      this.topic = topic;
      if (mode !== 'picker') {
        this.showBtn = true;
      }
      const data = await getLongCircleInfo(circleId);
      this.studyInfo = data;
    },
    async reqSignInfo() {
      const data = await getSignImage();
      const { englishContent, chineseContent, backgroundImage } = data;
      this.signInfo = {
        englishContent,
        chineseContent,
        backgroundImage,
      };
      this.getImgLoadEd([this.avatar, backgroundImage]);
    },
    // 所有图片加载完成
    getImgLoadEd(images) {
      const promises = images.map((item) => new Promise((resolve) => {
        const loadImg = new Image();
        loadImg.src = item;
        loadImg.crossOrigin = 'anonymous';
        loadImg.onload = () => {
          resolve(item);
        };
      }));

      Promise.all(promises).then(() => {
        setTimeout(() => {
          // canvas
          html2canvas(document.getElementById('longshare'), {
            dpi: 300,
            useCORS: true,
            backgroundColor: 'transparent', // 圆角问题
          }).then((canvas) => {
            // this.imgBeforeShow = false;
            const dataURL = canvas.toDataURL('image/png', 1.0);
            this.dataUrl = dataURL;
          });
        }, 1000);
      }).catch((e) => {
        console.log(e);
      });
    },
    goLongSentenceList() {
      if (whatEev() === 'miniprogram') {
        wx.miniProgram.redirectTo({
          url: '/longSentences/list/list',
        });
      } else {
        console.log('/longSentences/list/list');
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .7);
  z-index: 100;
  padding-top: 500px
}

.box {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.bg {
  width: 100vw;
  height: 100vh;
}

.modal {
  width: 100vw;
  background: rgba(0, 0, 0, .7);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.success {
  width: 370px;
  height: 80px;
  margin-bottom: 10px;
}

.container {
  width: 678px;
  height: 870px;
  border-radius: 22px;
  background-repeat: no-repeat;
  background-size: 100%;
  // position: relative;
  position: absolute;
  left: 100%;
}

.pic {
  width: 678px;
  height: 870px;
}

.bottom {
  width: 678px;
  height: 453px;
  background-repeat: no-repeat;
  background-size: 100%;
  position: absolute;
  bottom: 0;
  background-image: url(../../assets/img/public/bottom.png);
}

.english {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 29px;
  color: #434343;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  padding: 65px 43px 22px;
}

.chinese {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 22px;
  color: #434343;
  line-height: 31px;
  text-align: left;
  font-style: normal;
  padding: 0 43px;
}

.info {
  display: flex;
  justify-content: space-between;
  padding: 72px 43px 22px;

  .avatar {
    width: 87px;
    height: 87px;
    border-radius: 50%
  }

  .desc {
    margin-left: 22px;
    flex: 1;
    display: flex;
    align-items: center;
  }

  .nickname {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 25px;
    color: #262626;
    line-height: 36px;
    text-align: left;
    font-style: normal;
    margin: 6px 0;
  }

  .days {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    line-height: 31px;
    text-align: left;
    font-style: normal;
  }
}

.data {
  padding: 0 43px;
  height: 94px;
  display: flex;
  align-items: center;
  margin-bottom: 25px;

  &-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  &-border {
    width: 2px;
    height: 47px;
    background: #F6F6F6;
    margin: 0 47px;
  }

  .text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #9B9B9B;
    line-height: 31px;
    text-align: center;
    font-style: normal;
  }

  .num {
    font-family: Arial, Arial;
    font-weight: normal;
    font-size: 36px;
    color: #333333;
    line-height: 42px;
    text-align: center;
    font-style: normal;
  }

  .unit {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    line-height: 31px;
    text-align: left;
    font-style: normal;
    margin-left: 7px
  }
}

.bottom-border {
  width: 605px;
  height: 2px;
  background: #F5F5F5;
  margin: 0 auto;
}

.intro {
  height: 152px;
  width: 100%;
  padding: 25px 43px 0;
  display: flex;

  &-left {
    margin-left: 22px;
    flex: 1;
    align-items: center;
  }

  .logo {
    width: 132px;
    height: 40px;
  }

  &-desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 25px;
    color: #434343;
    line-height: 36px;
    text-align: left;
    font-style: normal;
  }

  &-code {
    height: 109px;
  }
}

.tip {
  width: 678px;
  height: 60px;
  line-height: 60px;
  border-radius: 20px;
  text-align: center;
  font-size: 24px;
  color: #fff;
}

.review {
  width: 678px;
  height: 80px;
  background: #FF7F41;
  border-radius: 45px;

  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 29px;
  color: #FFFFFF;
  line-height: 80px;
  text-align: center;
  font-style: normal;
}
</style>
